import { tenant } from '../index'
import { parseAccountsQueryParams } from '../../../../application/routing/parse-accounts-query-params'

export function getAccountsURL (): string {
  const baseUrl = `${typeof process.env.URL_LOGIN !== 'undefined' ? process.env.URL_LOGIN.replace('[[TENANT]]', tenant.tenant) : tenant.tenant}`
  const params = location.search != null ? location.search.replace('?', '').split('&').map(keyValue => ({ key: keyValue.split('=')[0], value: keyValue.split('=')[1] })) : null

  return baseUrl + parseAccountsQueryParams({
    pathname: location.pathname,
    queryParams: params,
    subdomain: tenant.subdomain ?? undefined
  })
}
